module.exports = __webpack_public_path__ + "img/DSC04034.dde52c96.jpg";